import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { feeChangeCommand } from '../../command/fee-change.command';
import { FeeChangeRevertCommandHandler } from './fee-change-revert-command-handler.service';

@Injectable()
export class FeeChangeCommandHandlerResolver extends CommandHandlerResolver {
  constructor(revertHandler: FeeChangeRevertCommandHandler) {
    super();
    this.addHandler(feeChangeCommand.revert, revertHandler);
  }
}
